/**
 * <bhg-addon> — optional add-on tick boxes for a product form.
 * Each ticked add-on enables its hidden items[] inputs. Shopify adds the form's own id/quantity
 * line plus every items[] line, so the main product and the ticked add-ons go in one request.
 */
class BhgAddon extends HTMLElement {
  connectedCallback() {
    this.options = [...this.querySelectorAll('.bhg-addon__option')];
    this.form = document.getElementById(this.dataset.formId);
    if (!this.options.length || !(this.form instanceof HTMLFormElement)) return;

    this.onChange = () => this.update();
    this.onSubmit = (/** @type {Event} */ event) => {
      if (event.target === this.form) this.syncItems();
    };

    this.addEventListener('change', this.onChange);
    // Horizon handles submit in a document capture listener, so sync on window capture to run first.
    window.addEventListener('submit', this.onSubmit, { capture: true });
    this.update();
  }

  disconnectedCallback() {
    this.removeEventListener('change', this.onChange);
    window.removeEventListener('submit', this.onSubmit, { capture: true });
  }

  /** Enable the hidden inputs of ticked add-ons only, and update the bundle message. */
  update() {
    let ticked = 0;
    for (const option of this.options) {
      const checked = option.querySelector('.bhg-addon__checkbox')?.checked ?? false;
      option.querySelectorAll('input[type="hidden"]').forEach((input) => (input.disabled = !checked));
      if (checked) ticked += 1;
    }
    this.updateBundle(ticked);
  }

  /** @param {number} ticked */
  updateBundle(ticked) {
    const bundle = this.querySelector('.bhg-addon__bundle');
    const status = this.querySelector('.bhg-addon__bundle-status');
    if (!(bundle instanceof HTMLElement) || !(status instanceof HTMLElement)) return;

    const needed = Number(bundle.dataset.bundleCount) || 2;
    const remaining = needed - ticked;
    let state = 'none';
    let text = status.dataset.statusNone ?? '';

    if (remaining <= 0) {
      state = 'done';
      text = status.dataset.statusDone ?? '';
    } else if (ticked > 0) {
      state = 'some';
      text = (status.dataset.statusSome ?? '').replace('[n]', String(remaining));
      if (remaining > 1) text = text.replace('more oil', 'more oils');
    }

    bundle.dataset.state = state;
    status.textContent = text;
  }

  /** Number the ticked add-on lines in order. */
  syncItems() {
    let index = 0;
    for (const option of this.options) {
      const id = option.querySelector('[data-addon-id]');
      const qty = option.querySelector('[data-addon-quantity]');
      if (!(id instanceof HTMLInputElement) || !(qty instanceof HTMLInputElement) || id.disabled) continue;
      id.name = `items[${index}][id]`;
      qty.name = `items[${index}][quantity]`;
      index += 1;
    }
  }
}

if (!customElements.get('bhg-addon')) customElements.define('bhg-addon', BhgAddon);
